import React, { Component } from 'react'
import { string, func } from 'prop-types'
import { Icon } from 'components'

export class McGameListInputText extends Component {
    static proptTypes = {
        label: string.isRequired,
        value: string,
        placeholder: string,
        onChange: func.isRequired,
    }
    static defaultProps = {
        value: null,
        placeholder: undefined,
    }

    handleChange = event => {
        const { onChange } = this.props
        onChange(event.target.value)
    }
    handleReset = () => {
        const { onChange } = this.props
        onChange(null)
    }

    render() {
        const { label, value, placeholder } = this.props
        const valueString = value || ''
        return (
            <div className="McGameList-FormGroup FG-InputText">
                <div className="McGameList-FormGroup-Label">{label}&nbsp;</div>
                <div className="McGameList-FormGroup-InputWrapper">
                    <Icon name="search" />
                    <input
                        type="text"
                        value={valueString}
                        onChange={this.handleChange}
                        placeholder={placeholder === undefined ? label : placeholder}
                    />
                    <div
                        className={['McGameList-FormGroup-Cancel', { Show: !!value }]}
                        onClick={this.handleReset}
                    >
                        x
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/GameList/Filters/McGameListInputText.js